function MyGuideIcon() {
    return (
        <svg width="21" height="28" viewBox="0 0 21 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_5335_10279)">
                <path d="M12.25 0L21 8.75H14C13.032 8.75 12.25 7.96797 12.25 7V0Z" fill="#00995D"/>
                <path opacity="0.4" d="M3.5 0C1.56953 0 0 1.56953 0 3.5V24.5C0 26.4305 1.56953 28 3.5 28H17.5C19.4305 28 21 26.4305 21 24.5V8.75H14C13.032 8.75 12.25 7.96797 12.25 7V0H3.5Z" fill="#00995D"/>
            </g>
            <defs>
                <clipPath id="clip0_5335_10279">
                <rect width="21" height="28" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    )
}

export default MyGuideIcon;